import { Typography } from '@mui/material';
import { Pagination, useListContext, useLocaleState, useTranslate } from 'react-admin';

import { LIVE_LOGS_I18N, LIVE_LOGS_ROWS_PER_PAGE_OPTIONS, LIVE_LOGS_TOTAL_CAP } from './liveLogs';

/** Hidden in the error state, where react-admin would otherwise page an error message. */
export const LiveLogsPagination = () => {
  const { error, total } = useListContext();
  const translate = useTranslate();
  const [locale] = useLocaleState();

  if (error) {
    return null;
  }

  return (
    <>
      {total != null && total >= LIVE_LOGS_TOTAL_CAP && (
        <Typography variant="caption" component="p" sx={{ px: 2, pt: 1, textAlign: 'right' }}>
          {translate(`${LIVE_LOGS_I18N}.capped`, { count: LIVE_LOGS_TOTAL_CAP.toLocaleString(locale) })}
        </Typography>
      )}
      <Pagination rowsPerPageOptions={LIVE_LOGS_ROWS_PER_PAGE_OPTIONS} />
    </>
  );
};
